import React, {useEffect} from 'react';
import {Outlet, useNavigate} from 'react-router-dom';
import {get} from 'lodash';
import {useStore} from '../../store';
import {requiresPasswordChange} from '../../utils/requiresPasswordChange';
import {OverlayLoader} from '../../components/loader';

const PasswordRouteGuard = () => {
    const user = useStore((state) => get(state, 'user', null));
    const navigate = useNavigate();

    const needsChange = requiresPasswordChange(user);

    useEffect(() => {
        if (!user) {
            return;
        }
        if (needsChange) {
            navigate('/password-change', {replace: true});
        }
    }, [user, needsChange, navigate]);

    if (!user) {
        return null;
    }

    if (needsChange) {
        return <OverlayLoader/>;
    }

    return <Outlet/>;
};

export default PasswordRouteGuard;
